import { api } from '../core/api';

export const getSupportedLanguages = () =>
  api.get<string[]>('Language/GetSupportedLanguages').then((res) => res.data);
export const getDefaultLanguage = () =>
  api.get<string>('Language/GetDefaultLanguage').then((res) => res.data);
